import styled from "styled-components";
import { BREAKPOINTS } from "../../variables/Breakpoints";
import { setFlex, setPosition } from "../../variables/Position";

export const GalleryWrapper = styled.div`
  ${setPosition({ position: "relative" })};
  ${setFlex({ direction: "column" })};
  height: 90vh;
  width: 100%;
  overflow: hidden;
`;

export const GalleryContainer = styled.div`
  ${setFlex({ align: "center" })};
  ${setPosition({ position: "absolute" })};
  height: 100%;
  width: max-content;
  will-change: transform;
`;

export const ImageWrapper = styled.div`
  ${props =>
    setFlex({
      justify: "center",
      align: props.$align,
    })};
  height: 100%;
`;

export const ImageContainer = styled.div`
  min-width: fit-content;
  max-width: 70vw;
  height: fit-content;
  margin-right: 5rem;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    max-width: 80vw;
  }
  @media (max-width: ${BREAKPOINTS.xs}px) {
    max-width: 100vw;
  }
`;

export const Image = styled.img`
  width: auto;
  max-width: 100%;
  ${props => props.$margin && `margin-${props.$margin}: 5rem`};
`;
